<section class="px-1 px-md-3 px-md-5 my-3">
    <div class="py-3" fxLayout="row" fxLayoutAlign="center center">
        <div fxLayout="column" fxFlex="100" fxFlex.gt-sm="50" fxLayoutAlign="center center">
            <img height="180px" src="assets/images/billy_not_found.svg" alt="Billy">
            <h1 class="pay-process-title">Ha ocurrido un problema</h1>
            <h2>{{this.message}}</h2>
            <button mat-raised-button color="primary" *ngIf="showButton" (click)="navigateToShipment()">
                Reintentar
            </button>
        </div>
        <h1></h1>
    </div>
</section>
